import React from 'react';

import { Pricing } from './pricing';

export const PricingContainer = ({ params, location }) => (
  <Pricing viewParams={{ ...params, query: location.query }} />
);
